export default "__VITE_ASSET__B28jR05u__"